import type { ComponentProps } from 'solid-js'
import { splitProps } from 'solid-js'

/**
 * Renders a themed form-field label.
 *
 * @param props - Standard label props.
 * @returns The label element.
 */
const FieldLabel = (props: ComponentProps<'label'>) => {
   const [local, rest] = splitProps(props, ['class'])
   return (
      <label
         {...rest}
         class={['mb-1 block text-sm font-medium text-ink-muted', local.class]
            .filter(Boolean)
            .join(' ')}
      />
   )
}

export default FieldLabel
